import { useEffect, useState } from 'react';

import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Cookies, Link, Snackbar, Text } from '@hh.ru/magritte-ui';
import { InfoCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';

import getDataQa from 'src/utils/getDataQa';

export const COOKIE_AGREEMENT_NAME = 'cookie_policy_agreement';
export const COOKIE_EXPIRE_TIME = 24 * 31 * 12;

const TrlKeys = {
    text: 'career-platform.components.cookies-policy.text',
    link: 'career-platform.components.cookies-policy.link',
    agree: 'career-platform.components.cookies-policy.agree',
};

const DATA_QA_BLOCK = 'cookies-policy';

const CookiesPolicy: TranslatedComponent = ({ trls }) => {
    const [isShow, setIsShow] = useState(false);

    const handleAgree = () => {
        Cookies.set(COOKIE_AGREEMENT_NAME, 'true', COOKIE_EXPIRE_TIME);
        setIsShow(false);
    };

    useEffect(() => {
        const cookieAgreementValue = Cookies.get(COOKIE_AGREEMENT_NAME);
        const isAlreadyAnswered = cookieAgreementValue !== null;

        if (!isAlreadyAnswered) {
            setIsShow(true);
        }
    }, []);

    if (!isShow) {
        return null;
    }

    return (
        <Snackbar
            addon={<InfoCircleFilledSize24 initial="contrast" />}
            autohideTime={0}
            actionLabel={trls[TrlKeys.agree]}
            onAction={handleAgree}
            data-qa={getDataQa(DATA_QA_BLOCK)}
        >
            <Text typography="label-2-regular" style="contrast">
                {trls[TrlKeys.text]}
            </Text>
            <Link
                style="contrast"
                typography="label-2-regular"
                href="https://hh.ru/article/cookie_policy"
                target="_blank"
                rel="noreferrer noopener nofollow"
                data-qa={getDataQa(DATA_QA_BLOCK, 'confirm')}
            >
                {trls[TrlKeys.link]}
            </Link>
        </Snackbar>
    );
};

export default translation(CookiesPolicy);
